<div class="b-b b-col-5 p-b p-r-2 p-l-2">
    <div class="flex flex-justify-between flex-middle cursor-pointer col-1 p-t"
         (click)="toggle()">

        <!-- title -->
        <div class="flex-grow w-12 _title">
            <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
        </div>


        @if (filter.hasSelection) {
        <div class="b-radius-max bg-col-6 flex flex-middle flex-justify-center"
             [style.width.px]="16"
             [style.height.px]="16">
            <p class="c1 col-w">{{filter.getSelectedOptions().length}}</p>
        </div>
        }
        <!-- icon -->
        <i [style.font-size.px]="16"
           [ngClass]="[toggleState ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
    </div>

    <!-- body -->
    <div class="_animate"
         [hideUp]="toggleState">
        <div class="m-t-3 overflow-auto custom-scrollbar"
             style="max-height: 214px;">
            <div class="p-b-1 overflow-hidden">
                <!-- For some reasons we need overflow-hidden cause on mobile scroll apear from nowhere -->
                <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
            </div>
        </div>

    </div>
</div>

<ng-template #expandableTitleTpl>
    <div class="flex flex-middle overflow-hidden">
        @if (filter.attribute.data?.label) {
        <span class="s2">{{filter.attribute.data.label}}</span>
        }
    </div>
</ng-template>
<ng-template #expandableBodyTpl>
    @for (option of filter.optionsWithCurrentMatches; track option.value; let isFirst = $first; let isLast = $last) {
    @switch (filter.attribute.data?.isSwatch) {
    @case(true) {
    <div (click)="filter.toggle(option)"
         class="cursor-pointer m-b-0 m-t c-6-set"
         [class.is-disabled]="filter.isUnavailble(option)">
        <div class="flex w-12">
            <!-- swatch icon -->
            <swatch [option]=" option"
                    [style.width.px]="24"
                    [selected]="filter.isSelected(option)"
                    class="inline-block va-m flex-noshrink"></swatch>
            <!-- label -->
            <label class="p2 col-1 inline-block va-m m-l-3 flex-grow">{{option.label}}</label>
        </div>
    </div>
    }
    @default {
    <checkbox [class.p-t-3]="!isFirst">
        <input class="m-r-2"
               type="checkbox"
               name="checkboxFilters"
               [checked]="filter.isSelected(option)"
               (change)="filter.toggle(option)" />
        <p class="p2">
            {{option.label}}@if (!!option.count) {
            ({{filter.getCurrentMatchesCount(option)}})
            }
        </p>
    </checkbox>
    }
    }
    }
</ng-template>